export default __webpack_public_path__ + "d6349d0.png";